export enum StatusColorId {
  Green = 1,
  PastelGreen,
  Orange,
  Yellow,
  Pink,
  Violet,
  Blue,
  Grey,
  Red,
}

export const getStatusColorIdToTextMap = (): Record<StatusColorId, string> => {
  const miscStrings = tiStrings.app.misc;

  return {
    [StatusColorId.Green]: miscStrings.green,
    [StatusColorId.PastelGreen]: miscStrings.pastelGreen,
    [StatusColorId.Orange]: miscStrings.orange,
    [StatusColorId.Yellow]: miscStrings.yellow,
    [StatusColorId.Pink]: miscStrings.pink,
    [StatusColorId.Violet]: miscStrings.violet,
    [StatusColorId.Blue]: miscStrings.blue,
    [StatusColorId.Grey]: miscStrings.grey,
    [StatusColorId.Red]: miscStrings.red,
  };
};

export const getWorkflowStatusColorIdToTextMap = (): Record<number, string> => {
  const miscStrings = tiStrings.app.misc;
  return {
    1: miscStrings.green,
    2: miscStrings.orange,
    3: miscStrings.default,
    4: miscStrings.red,
  };
};

export enum ActionColors {
  ActionsGreen = '--text-confirmation',
  ActionsRed = '--text-distructive',
  ActionsBlue = '--text-brand-saturated',
  ActionsOrange = '--text-warning-saturated',
}

export enum StatusColors {
  StatusesOrange = '--bg-accent-orange-solid-subtle-hover',
  StatusesPink = '--bg-accent-pink-solid-subtle-hover',
  StatusesGreen = '--bg-accent-green-solid-subtle-hover',
  StatusesPastelGreen = '--bg-accent-pastel-green-solid-subtle-hover',
  StatusesRed = '--bg-accent-red-solid-subtle-hover',
  StatusesRedTransparent = '--bg-accent-red-solid-subtlest-hover',
  StatusesGrey = '--bg-neutral-solid-subtle-hover',
  StatusesBlue = '--bg-accent-blue-solid-subtle-hover',
  StatusesDandellion = '--bg-accent-yellow-solid-subtle-hover',
  StatusesViolet = '--bg-accent-purple-solid-subtle-hover',
}

export const statusColorIdToCssClass: Record<StatusColorId, StatusColors> = {
  [StatusColorId.Green]: StatusColors.StatusesGreen,
  [StatusColorId.PastelGreen]: StatusColors.StatusesPastelGreen,
  [StatusColorId.Orange]: StatusColors.StatusesOrange,
  [StatusColorId.Yellow]: StatusColors.StatusesDandellion,
  [StatusColorId.Pink]: StatusColors.StatusesPink,
  [StatusColorId.Violet]: StatusColors.StatusesViolet,
  [StatusColorId.Blue]: StatusColors.StatusesBlue,
  [StatusColorId.Grey]: StatusColors.StatusesGrey,
  [StatusColorId.Red]: StatusColors.StatusesRed,
};
